import Vue from 'vue';

export const EventBus = new Vue();

export const Events = {
  NEW_GAME_STARTED: 'NEW_GAME_STARTED',
};
